import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import IconArrowGray from '../../../../img/icons/svg/botones/flecha-big-gris.svg';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import SolicitudCATAFuego from './SolicitudCATAFuego';
import useGetSolicitudCATAFuegoByID from 'services/record/SolicitudCATAFuego/useGetSolicitudCATAFuegoByID';

const HistorialSolicitudCATAFuego = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode('token');
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { getSolicitudCATAFuegoByID, loadingGetSolicitudCATAFuegoByID } = useGetSolicitudCATAFuegoByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();

    const origenValue = location?.state?.origen ?? origen ?? null;
    const expedienteIdValue = location?.state?.expedienteId ?? expedienteId ?? null;
    const expedienteIdByOrigen = Number(origenValue) === 1 ? (expedienteIdValue ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload: any) => (
        expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined
            ? { ...payload, ExpedienteId: expedienteIdByOrigen }
            : payload
    );

    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getSolicitudCATAFuegoByID(userId, prestacionId, formId, (payload: any) => setData(dataUserWithExpedienteByOrigen(payload)));
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title="Solicitud CATA por fuerza mayor como consecuencia de incendios forestales">
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            {loadingGetSolicitudCATAFuegoByID
                ? <Loader activeLoader={true} label="Cargando Formulario" />
                : <SolicitudCATAFuego dataUser={data} info={false} />}
        </div>
    );
};

export default HistorialSolicitudCATAFuego;